<template>
  <div class="products-kww-page-content flex flex-col items-center w-full text-left">
    <!-- banner 包含移动端 -->
    <PageBanner :content="content.bannerInfo" />

    <PageBusinessCol :content="content.businessIntroduction" />

    <!-- 产品功能介绍 中间左右布局的内容 -->
    <PageFunction :content="content.featuresIntroduction" />

    <!-- 产品优势 -->
    <PageAdvantage :content="content.advantage" :extraTitleStyle="{ color: '#ffffff' }" />

    <SiteMap />
  </div>

</template>

<script setup lang="ts">
import { ref, shallowReactive, onMounted, onUnmounted } from 'vue'
import { useSeoMeta } from 'nuxt/app'
const title = '和掌贵'
const description = '数字化会员中心  赋能门店新增长'
useSeoMeta({
  title,
  description,
})

const content = shallowReactive({
  bannerInfo: {
    banner: '/images/pages/products/kww/hzg- (1).png',
    // title: '和掌贵',
    // description: '数字化会员中心  赋能门店新增长',
    mobileBanner: '/images/mobile/products/hzg- (2).png'
  },
  businessIntroduction: {
    title: '产品业务介绍',
    description: [
      '和掌贵，以多品类在线兑奖和智能一键要货系统为核心构建便捷高效的综合商家会员管理体系',
      '显著提升门店铺货率与运营效率，整合数据搭建专属用户池，深度描绘精准的商家画像',
      '为门店的精准营销与生态化运营提供坚实的数据支撑与决策依据，驱动生意持续增长以及品牌力提升。'
    ],
    descImage: '/images/pages/products/kww/sj- (4).png',
  },
  featuresIntroduction: {
    title: '产品功能介绍',
    desc: '',
    extraCardBackColor: 'bg-#FBFDFF',
    extraTitleClass: 'bg-#FBFDFF w-100%!',
    groups: [
      {
        title: '兑奖核销',
        desc: '',
        descList: [
          '兑奖流程线上化，一键兑奖',
          '数据跨平台流转，一键返货确认完成闭环',
        ],
        icon: '/images/pages/products/kww/f-i- (1).png',
        mainImage: '/images/pages/products/kww/sj- (5).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '采购铺货',
        desc: '',
        descList: ['门店通过平台发起要货,数据推送至指定业务员，跨平台发起返货完成铺货业务',],
        icon: '/images/pages/products/kww/f-i- (2).png',
        mainImage: '/images/pages/products/kww/f- (2).png',
        direction: 'copywriting-to-image'
      },
      {
        title: '开袋有礼',
        desc: '',
        descList: ['四码关联，产品溯源', '门店扫码精准定向，动态奖励配置促进终端进货、销售'],
        icon: '/images/pages/products/kww/f-i- (3).png',
        mainImage: '/images/pages/products/kww/f- (3).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '资产管理',
        desc: '',
        descList: ['多资产体系灵活管理，涵盖消费余额、定向余额、积分、成长值等',],
        icon: '/images/pages/products/kww/f-i- (4).png',
        mainImage: '/images/pages/products/kww/f- (4).png',
        direction: 'copywriting-to-image'
      },
      {
        title: '营销互动',
        desc: '',
        descList: ['搭建多种类型的互动营销工具，提高用户活跃度，增加用户粘性，助力品牌影响力提升',],
        icon: '/images/pages/products/kww/f-i- (5).png',
        mainImage: '/images/pages/products/kww/f- (5).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '店铺权益',
        desc: '',
        descList: ['根据用户活跃、消费等属性划分店铺等级，区分不同类型店铺权益，筛选优质客户，提升服务质量',],
        icon: '/images/pages/products/kww/f-i- (6).png',
        mainImage: '/images/pages/products/kww/sj- (3).png',
        direction: 'copywriting-to-image'
      }, {
        title: '财务中心',
        desc: '',
        descList: ['实时交易流水，月度、年度账单，不同币种结算模型，综合性统计、结算、票据管理中心',],
        icon: '/images/pages/products/kww/f-i- (7).png',
        mainImage: '/images/pages/products/kww/f- (7).png',
        direction: 'image-to-copywriting'
      }, {
        title: '数据中心',
        desc: '',
        descList: ['涵盖店铺数据、用户数据、行为数据、交易数据的综合性数据中心，助力运营分析与品牌决策'],
        icon: '/images/pages/products/kww/f-i- (8).png',
        mainImage: '/images/pages/products/kww/f- (8).png',
        direction: 'copywriting-to-image'
      },
    ]
  },
  advantage: {
    title: '产品优势',
    background: '/images/pages/products/kww/advance-back.png',
    extraTitleStyle: {
      color: 'white',
    },
    list: [
      {
        briefBack: '/images/pages/products/kww/b-card- (2).png',
      },
      {
        briefBack: '/images/pages/products/kww/b-card- (3).png',
      },
      {
        briefBack: '/images/pages/products/kww/sj- (2).png',
      },
      {
        briefBack: '/images/pages/products/kww/b-card- (1).png',
      },
    ]
  }
})

</script>

<style scoped lang="scss">
@import "@base/@core/scss/template/libs/vuetify/variables";

.products-kww-page-content {
  max-width: $page-max-width;
  background-color: #fff;

  @media (max-width: 1023.9px) {
    padding-top: $table-header-height;
  }

  .kww-business-number-cooperative-stores {
    position: absolute;
    top: 120px;
    right: 0;
    display: flex;
    width: 16.5rem;
    height: 5.32rem;
    padding-top: 20px;
    padding-left: 30px;
    border-radius: 0;
    background-image: url("/images/pages/products/kww/Frame 2147229605@2x.png");
    background-size: cover;
  }

  .features-group-ul {
    .features-group-li {
      position: relative;
      padding-left: 2rem;

      &::before {
        position: absolute;
        z-index: 0;
        top: 5px;
        left: 0;
        width: 19px;
        height: 19px;
        background-image: url("/images/pages/products/kww/圆点.png");
        background-size: cover;
        content: "";
      }
    }
  }
}

.kww-product-advantage {
  background-image: url("/images/pages/products/kww/product_bottom_next.png");
  background-size: cover;
}

.accordion-container {
  display: flex;
  height: 300px;
  gap: 1rem;

  .accordion-item {
    overflow: hidden;
    flex: 1;
    cursor: pointer;
    transition: all 1s ease;

    &:hover,
    &.active {
      flex: 3;
    }

    :deep(img) {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 1s ease;
    }

    &:not(.active):hover :deep(img) {
      // transform: scale(1.05);
    }
  }
}
</style>
